export const WORKSPACES = 'WORKSPACES'
export const WORKSPACES_STATUS = 'WORKSPACES_STATUS'
export const WORKSPACE_STATUS = 'WORKSPACE_STATUS'
export const SELECTED_WORKSPACE = 'SELECTED_WORKSPACE'
